module.exports = __webpack_public_path__ + "static/media/ENCONTRO_5_ED_FISICA.2dd821e4.pdf";